<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Substeps (read-only in summary)
import Umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import PEP from '../../Shared/PEP.vue'
import Step6 from './Step6.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

const expanded = ref([0])

</script>

<template>
  <div v-if="umsokn" class="col-sm-12">
    <!-- Header -->
    <v-row>
      <v-col>
        <h2 class="forms__header">
          {{ t('umsokn_samantekt_header') }}
        </h2>
      </v-col>
    </v-row>

    <!-- Intro -->
    <v-row>
      <v-col>
        <p>{{ t('umsokn_samantekt_header2') }}</p>
      </v-col>
    </v-row>

    <!-- Summary expansion -->
    <v-row>
      <v-col class="application__summary">
        <v-expansion-panels v-model="expanded">
          <v-expansion-panel>
            <v-expansion-panel-title>
              {{ t('umsokn_samantekt_upplysingar') }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div><Umsaekjandi :disable="true" /></div>
              <div class="m-t-100"><Step2 :disable="true" /></div>
              <div class="m-t-100"><Step3 :disable="true" /></div>
              <div class="m-t-100"><Step4 :disable="true" /></div>
              <div class="m-t-100"><Step5 :disable="true" /></div>
              <div class="m-t-100"><PEP :disable="true" :showDisclamer="false" /></div>
              <div class="m-t-100"><Step6 :disable="true" /></div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped lang="scss">
.application__summary {
  width: 100%;
}
.m-t-100 {
  margin-top: 100px;
}
</style>
